import { combineReducers, Reducer } from "redux";

import { EMPTY_ARRAY, EMPTY_OBJECT } from "@multiweb/reactUtils";
import { IWorkflowMenuItem } from "@multiweb/types/multiweb";
import { FetchingState, MutableTypedObject, TypedObject } from "@multiweb/types/react";
import { DATA_SOURCE_INIT_STATE } from "../initState";
import {
    ILoadWorkflowActionsAction,
    ILoadWorkflowActionsErrorAction,
    ILoadWorkflowActionsSuccessAction,
    IWorkflowActions,
} from "../types";

const actions: Reducer<TypedObject<IWorkflowMenuItem>> = (
    state = DATA_SOURCE_INIT_STATE.workflowActions.actions,
    action,
) => {
    if (action instanceof ILoadWorkflowActionsAction || action instanceof ILoadWorkflowActionsErrorAction) {
        return EMPTY_OBJECT;
    } else if (action instanceof ILoadWorkflowActionsSuccessAction) {
        const newWorkflowActions: MutableTypedObject<IWorkflowMenuItem> = {};
        action.payload.workflowActions.forEach((workflowAction) => {
            newWorkflowActions[workflowAction.ID] = workflowAction;
        });
        return newWorkflowActions;
    }
    return state;
};

const actionsOrder: Reducer<ReadonlyArray<string>> = (
    state = DATA_SOURCE_INIT_STATE.workflowActions.actionsOrder,
    action,
) => {
    if (action instanceof ILoadWorkflowActionsAction || action instanceof ILoadWorkflowActionsErrorAction) {
        return EMPTY_ARRAY;
    } else if (action instanceof ILoadWorkflowActionsSuccessAction) {
        return action.payload.workflowActions.map(workflowAction => workflowAction.ID);
    }
    return state;
};

const fetchingState: Reducer<FetchingState> = (
    state = DATA_SOURCE_INIT_STATE.workflowActions.fetchingState,
    action,
) => {
    if (action instanceof ILoadWorkflowActionsAction) {
        return FetchingState.request;
    } else if (action instanceof ILoadWorkflowActionsSuccessAction) {
        return FetchingState.success;
    } else if (action instanceof ILoadWorkflowActionsErrorAction) {
        return FetchingState.error;
    }
    return state;
};

export const workflowReducer: Reducer<IWorkflowActions> = combineReducers({
    actions,
    actionsOrder,
    fetchingState,
});
